import { render, staticRenderFns } from "./item.vue?vue&type=template&id=9d0ff2e2&scoped=true"
import script from "./item.js?vue&type=script&lang=js&external"
export * from "./item.js?vue&type=script&lang=js&external"
import style0 from "./item.scss?vue&type=style&index=0&id=9d0ff2e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0ff2e2",
  null
  
)

export default component.exports